import { Reducer } from 'redux'
import { IMarketplaceStore } from 'apps/marketplace/store/types'
import { filterRates } from 'apps/marketplace/utils/helpers/rates'
import { CARRIER_CONTRACT_LANES_ACTION_TYPES as c } from './actions'
import { ICarrierContractLanesState, IDatLane, IRate, ILaneRate } from './types'

const initState = {
  data: {
    datLane: undefined,
    laneRates: [],
    radiusRates: [],
  },
  loading: false,
  error: '',
}

interface ICarrierContractLanesResponsePayload {
  carriercontractlanes: IRate[]
  datMarketLane: IDatLane
}

type CarrierContractLanesActions =
  | { type: c.FETCH_CARRIER_CONTRACT_LANES_REQUEST }
  | { type: c.FETCH_CARRIER_CONTRACT_LANES_SUCCESS; payload: ICarrierContractLanesResponsePayload }
  | { type: c.FETCH_CARRIER_CONTRACT_LANES_FAILURE; error: string }

/** Reducer */
const carrierContractLanesReducer: Reducer<
  ICarrierContractLanesState,
  CarrierContractLanesActions
> = (
  state: ICarrierContractLanesState = initState,
  action: CarrierContractLanesActions
): ICarrierContractLanesState => {
  switch (action.type) {
    case c.FETCH_CARRIER_CONTRACT_LANES_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case c.FETCH_CARRIER_CONTRACT_LANES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          datLane: action.payload.datMarketLane,
          ...filterRates(action.payload.carriercontractlanes),
        },
      }
    case c.FETCH_CARRIER_CONTRACT_LANES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}

export default carrierContractLanesReducer

/** Selectors */
export const selectLaneInfo = (state: IMarketplaceStore): IDatLane | undefined =>
  state.carrierContractLanes.data.datLane

export const selectLaneRates = (state: IMarketplaceStore): ILaneRate[] =>
  state.carrierContractLanes.data.laneRates

export const selectRadiusRates = (state: IMarketplaceStore): ILaneRate[] =>
  state.carrierContractLanes.data.radiusRates

export const selectContractLaneLoading = (state: IMarketplaceStore): boolean =>
  state.carrierContractLanes.loading

export const selectContractLaneError = (state: IMarketplaceStore): string =>
  state.carrierContractLanes.error
